import React from 'react';
import './Footer.css';
import { useTranslation } from 'react-i18next';
//import { urls } from '../router/urls';
import { Link } from 'react-router-dom';

const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer className="site-footer">
			<nav className="sitemap-nav" role="navigation" aria-label={t('footer_sitemap_aria')}>
				<h2 id="footer-collections-title">{t('footer_red_aprende')}</h2>
				<ul aria-labelledby="footer-collections-title">
					<li>
						<Link to="/colecciones" aria-label={t('footer_collections_aria')}>{t('footer_collections')}</Link>{/* TODO: Definir ruta para "Nosotros" */}
					</li>
					<li>
						<a href="https://www.mineducacion.gov.co/1759/articles-353715_recurso_5.pdf" aria-label={t('footer_data_treatment_aria')}>{t('footer_data_treatment')}</a>
					</li>
					<li>
						<a href="https://www.colombiaaprende.edu.co/terminos-y-condiciones" aria-label={t('footer_privacy_terms_aria')}>{t('footer_privacy_terms')}</a>
					</li>
					<li>
						<a href="https://www.mineducacion.gov.co/1759/articles-353715_recurso_7.pdf" aria-label={t('footer_digital_security_aria')}>{t('footer_digital_security')}</a>
					</li>
					<li>
						<a href="https://www.colombiaaprende.edu.co/politicas-cookies" aria-label={t('footer_cookies_aria')}>{t('footer_cookies')}</a>
					</li>
				</ul>

				<h2 id="footer-educational-level-title">{t('footer_educational_level')}</h2>
				<ul aria-labelledby="footer-educational-level-title">
					<li>
						<Link to="#" aria-label={t('footer_first_child_hood_aria')}>{t('footer_first_child_hood')}</Link>
					</li>
					<li>
						<Link to="#" aria-label={t('footer_preschool_basic_media_aria')}>{t('footer_preschool_basic_media')}</Link>
					</li>
					<li>
						<Link to="#" aria-label={t('footer_superior_education_aria')}>{t('footer_superior_education')}</Link>
					</li>
					<li>
						<Link to="#" aria-label={t('footer_work_human_development_education_aria')}>{t('footer_work_human_development_education')}</Link>
          </li>
				</ul>

				<h2 id="footer-areas-subjects-title">{t('footer_areas_subjects')}</h2>
				<ul aria-labelledby="footer-areas-subjects-title">
					<li>
						<Link to="#" aria-label={t('footer_science_math_aria')}>{t('footer_science_math')}</Link>{/* TODO: Definir ruta para "Lineamientos curriculares" */}
					</li>
					<li>
						<Link to="#" aria-label={t('footer_language_humanities_society_aria')}>{t('footer_language_humanities_society')}</Link>{/* TODO: Definir ruta para "Metodologías y estrategias" */}
					</li>
					<li>
						<Link to="#" aria-label={t('footer_art_culture_expression_aria')}>{t('footer_art_culture_expression')}</Link>{/* TODO: Definir ruta para "Evaluaciones e instrumentos" */}
					</li>
					<li>
						<Link to="#" aria-label={t('footer_physical_education_aria')}>{t('footer_physical_education')}</Link>{/* TODO: Definir ruta para "Evaluaciones e instrumentos" */}
					</li>
					<li>
						<Link to="#" aria-label={t('footer_health_wellness_aria')}>{t('footer_health_wellness')}</Link>{/* TODO: Definir ruta para "Evaluaciones e instrumentos" */}
					</li>
					<li>
						<Link to="#" aria-label={t('footer_healthy_habits_aria')}>{t('footer_healthy_habits')}</Link>{/* TODO: Definir ruta para "Evaluaciones e instrumentos" */}
					</li>
				</ul>

				<h2 id="footer-external-links-title">{t('footer_external_links')}</h2>
				<ul aria-labelledby="footer-external-links-title">
					<li>
						<a href="https://contenidos.ia.colombiaaprende.edu.co/recomendacion-de-contenidos" target="_blank" rel="noopener noreferrer" aria-label={t('footer_currideas_aria')}>{t('footer_currideas')}</a>{/* TODO: Definir ruta para "CurrIdeas" */}
					</li>
					<li>
						<a href="https://contenidos.ia.colombiaaprende.edu.co/" target="_blank" rel="noopener noreferrer" aria-label={t('footer_colombia_aprende_link_aria')}>{t('footer_colombia_aprende_link')}</a>{/* TODO: Definir ruta para "Colombia Aprende" */}
					</li>
				</ul>
			</nav>

			<address role="contentinfo">
				<h2>{t('footer_mineducacion_title')}</h2>
				<p>
					<span>{t('footer_address_label')}</span>
					<span>{t('footer_address_value')}</span>
				</p>
				<p>
					<span>{t('footer_phone_conmutator_label')}</span>
					<span>{t('footer_phone_conmutator_value')}</span>
					—
					<span>{t('footer_free_line_label')}</span>
					<span>{t('footer_free_line_value')}</span>
				</p>
				<p>
					<span>{t('footer_attention_schedule_label')}</span>
					<span>{t('footer_attention_schedule_value')}</span>
				</p>
				<p>
					<span>{t('footer_tech_support_label')}</span>
					<span>{t('footer_tech_support_value')}</span>
					—
					<span>{t('footer_national_free_line')}</span>
					<span>{t('footer_free_line_value')}</span>
				</p>
				<p>
					<span>{t('footer_anti_corruption_email_label')}</span>
					<span><a href="mailto:soytransparente@mineducacion.gov.co" bis_skin_checked="1" aria-label={t('footer_anti_corruption_email_aria')}>soytransparente@mineducacion.gov.co</a></span>
				</p>
				<p>
					<span>{t('footer_judicial_notifications_email_label')}</span>
					<span><a href="mailto:notificacionesjudiciales@mineducacion.gov.co" bis_skin_checked="1" aria-label={t('footer_judicial_notifications_email_aria')}>notificacionesjudiciales@mineducacion.gov.co</a></span>
				</p>
				<p>
					<Link to="#" aria-label={t('footer_channels_attention_aria')}>{t('footer_channels_attention')}</Link>{/* TODO: Definir ruta para "Canales físicos y electrónicos para atención al público" */}
				</p>
			</address>
			<nav className="social-nav simple-nav" role="navigation" aria-label={t('footer_social_networks_aria')}>
				<ul>
					<li>
						<a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label={t('footer_facebook_link_aria')}>@Mineducacion</a>{/* TODO: Definir URL para Facebook */}
					</li>
					<li>
						<a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label={t('footer_instagram_link_aria')}>@mineducacioncol</a>{/* TODO: Definir URL para Instagram */}
					</li>
					<li>
						<a href="https://x.com" target="_blank" rel="noopener noreferrer" aria-label={t('footer_x_link_aria')}>@Mineducacion</a>{/* TODO: Definir URL para X (Twitter) */}
					</li>
					<li>
						<a href="https://youtube.com" target="_blank" rel="noopener noreferrer" aria-label={t('footer_youtube_link_aria')}>@MinisteriodeEducacionNacional</a>{/* TODO: Definir URL para YouTube */}
					</li>
					<li>
						<a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label={t('footer_linkedin_link_aria')}>@MinisteriodeEducaciónNacional</a>{/* TODO: Definir URL para LinkedIn */}
					</li>
				</ul>
			</nav>
			<nav className="additional-nav simple-nav" role="navigation" aria-label={t('footer_interest_links_aria')}>
				<ul>
					<li>
						<Link to="#" aria-label={t('footer_terms_conditions_aria')}>{t('footer_terms_conditions')}</Link>{/* TODO: Definir ruta para "Términos y condiciones" */}
					</li>
					<li>
						<Link to="#" aria-label={t('footer_policies_aria')}>{t('footer_policies')}</Link>{/* TODO: Definir ruta para "Políticas" */}
					</li>
					<li>
						<Link to="#" aria-label={t('footer_sitemap_link_aria')}>{t('footer_sitemap')}</Link>{/* TODO: Definir ruta para "Mapa del sitio" */}
					</li>
					<li>
						<Link to="#" aria-label={t('footer_accessibility_aria')}>{t('footer_accessibility')}</Link>{/* TODO: Definir ruta para "Accesibilidad" */}
					</li>
				</ul>
			</nav>
			<p className="copy-colombia-aprende">
				{t('footer_platform_of')} <Link to="#" aria-label={t('footer_colombia_aprende_link_bottom_aria')}>{t('footer_colombia_aprende_link')}</Link>{/* TODO: Definir ruta para "Colombia Aprende" */}
			</p>
		</footer>
  );
};

export default Footer;


